// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__CCdWr","inner":"Form_inner__2EYJX","range":"Form_range__3cesL","name":"Form_name__3Ilm1","actions":"Form_actions__2taFI"};